const AuditLogAction = Object.freeze({
  create: 'AuditLog_Action_Create',
  delete: 'AuditLog_Action_Delete',
  update: 'AuditLog_Action_Update',
  reject: 'AuditLog_Action_Reject',
  skip: 'AuditLog_Action_Skip',
  sync: 'AuditLog_Action_Sync',
  merge: 'AuditLog_Action_Merge'
})

const AuditLogSource = Object.freeze({
  manual: 'AuditLog_Source_Manual',
  api: 'AuditLog_Source_API',
  sdk: 'AuditLog_Source_SDK',
  kafka: 'AuditLog_Source_Kafka',
  import: 'AuditLog_Source_Import',
  integration: 'AuditLog_Source_Integration',
  game: 'AuditLog_Source_Game',
  loyalty: 'AuditLog_Source_Loyalty',
  microsite: 'AuditLog_Source_Microsite',
  preference: 'AuditLog_Source_Preference',
  system: 'AuditLog_Source_System'
})

export { AuditLogAction, AuditLogSource }



// WEBPACK FOOTER //
// ./src/modules/profiles/enum/AuditLog.js